<template>
  <v-card>
    <v-form @submit.prevent="submitBillsForm()" ref="billingsForm">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="mr-2">
              <v-icon
                :color="$store.state.global.pages.billing.color"
              >{{$store.state.global.pages.billing.icon}}</v-icon>
            </span>
            <span class="headline">
              Create Bills
              <span class="grey--text subheading">
                -
                <span class="font-weight-bold">{{projectName}}</span> Dockets for the billing period of
                <span class="font-weight-bold">{{billingPeriod}}</span>
              </span>
            </span>
          </v-flex>
          <card-divider-header></card-divider-header>

          <v-flex class="text-xs-center" xs12 v-if="working">
            <v-progress-circular indeterminate :color="$store.state.global.pages.billing.color"></v-progress-circular>
            <div class="text-xs-center body-1 grey--text text--lighten-1 mt-3">Loading your data...</div>
          </v-flex>

          <template v-if="previewData">
            <flex-sub-header>{{ previewData.tripCount }} trips spanning {{previewData.docketCount}} dockets</flex-sub-header>
            <flex-sub-header v-if="!!previewData.adjustmentTripCount" class="red--text lighten-2">
              <span
                class="indigo--text font-italic"
              >including {{ previewData.adjustmentTripCount }} credit and adjustment trips</span>
            </flex-sub-header>
            <v-flex v-if="!!previewData.incompleteDockets.length">
              <v-alert
                :value="true"
                type="error"
                class="mb-3"
                outline
                style="border-radius: 4px;"
              >{{ previewData.incompleteDockets.length }} dockets were excluded because some of their trips were not confirmed</v-alert>
              <div
                v-for="(docketRef) in previewData.incompleteDockets"
                :key="docketRef"
                class="text-xs-left pl-2 body-2 grey--text"
              >
                -
                <a
                  href
                  @click.prevent="searchForDocket(docketRef)"
                  class="grey--text text--darken-1"
                >{{docketRef}}</a>
              </div>
            </v-flex>
            <card-divider-header></card-divider-header>
            <flex-sub-header>Sites</flex-sub-header>
          </template>

          <v-flex xs12 v-if="previewData">
            <v-expansion-panel popout>
              <v-expansion-panel-content v-for="(site,i) in previewData.subjects" :key="i">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2"
                >{{site.name}}</div>
                <v-card>
                  <v-list two-line dense>
                    <v-divider></v-divider>
                    <fancy-list-tile
                      icon="mail"
                      :color="$store.state.global.pages.site.color"
                      title="Email"
                      :subTitle="site.contactEmail"
                      type="email"
                    ></fancy-list-tile>

                    <fancy-list-tile
                      icon="phone"
                      :color="$store.state.global.pages.site.color"
                      title="Phone"
                      :subTitle="site.contactPhone"
                      type="phone"
                    ></fancy-list-tile>

                    <v-divider></v-divider>
                  </v-list>
                  <v-card-text>
                    <div class="body-2">Trips - {{site.tripCount}}</div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <flex-sub-header>
            Notes
            <div
              class="font-italic caption grey--text"
            >These notes will apply for all bills about to be created</div>
          </flex-sub-header>
          <v-flex xs12 sm6>
            <v-text-field label="Internal Notes" prepend-icon="note" v-model="internalNotes"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="Invoice Notes" prepend-icon="note" v-model="invoiceNotes"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
        <v-btn
          flat
          type="submit"
          color="green darken-1"
          :disabled="!previewData"
          :loading="loading"
        >Create</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import BillService from "@/services/requests/billService";
import DocketService from "@/services/requests/docketService";
export default {
  mounted() {
    this.getPreviewData();
  },
  data() {
    return {
      loading: false,
      working: false,
      internalNotes: "",
      invoiceNotes: "",
      previewData: null
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitBillsForm() {
      if (!this.previewData.tripIds.length) {
        this.snack({ color: "yellow", text: "No trips found!" });
        return;
      }
      this.addBills();
    },
    buildQuery() {
      var query = {};
      query.billingPeriod = this.billingPeriod;
      query.projectId = this.projectId;
      return query;
    },
    getPreviewData() {
      this.working = true;
      var getPreviewDataQuery = {
        type: "billing",
        query: this.buildQuery()
      };
      DocketService.getPreviewData(getPreviewDataQuery)
        .then(result => {
          this.working = false;
          //console.log(result.data.result);
          this.previewData = result.data.result;
        })
        .catch(err => {
          console.log(err);
          this.working = false;
        });
    },
    addBills() {
      this.loading = true;
      var bills = {
        internalNotes: this.internalNotes,
        invoiceNotes: this.invoiceNotes,
        trips: this.previewData.tripIds
      };
      BillService.addBills(bills)
        .then(result => {
          this.loading = false;
          this.resetForm();
          this.close();
          //console.log(result.data.result.createdBills);
          var billIds = result.data.result.createdBills.map(createdBill => {
            return createdBill.bill.id;
          });
          billIds = JSON.stringify(billIds);
          this.$router.push({ name: "billing", query: { ids: billIds } });
        })
        .catch(err => {
          console.log(err);
          this.snack({ text: err.response.data.message, color: "red" });
          this.loading = false;
        });
    },
    searchForDocket(docketRef) {
      this.$store.commit("trips/setState", {
        prop: "filterBy",
        value: docketRef
      });
    },
    resetForm() {
      this.internalNotes = "";
      this.invoiceNotes = "";
    }
  },
  props: {
    dialogOpen: Boolean
  },
  computed: {
    billingPeriod: Store.getSet({ store: "shared", prop: "billingPeriod" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    projectName() {
      if (!!this.projectId) {
        return this.$store.state.projects.projects.filter(project => {
          return project.id == this.projectId;
        })[0].name;
      } else {
        return "";
      }
    }
  },
  watch: {
    // billingPeriod(val) {
    //     this.previewData = null;
    //     this.getPreviewData()
    // },
    // projectId(val) {
    //     this.previewData = null;
    //     if (!!val) this.getPreviewData()
    // },
    dialogOpen(val) {
      if (val) {
        this.previewData = null;
        this.getPreviewData();
      }
    }
  }
};
</script>

<style>
</style>
